"use client";

import { c as _c } from "react/compiler-runtime";
import Avatar from "sigma-avatars";
import OptimizedImage from "@/components/optimized-image";
import { getDisplayImageUrl } from "@/lib/image-utils";
import type { LocalWalletIdentity } from "@/lib/local-wallet-identity";

/** Password unlock form when user has a local backup */
export function LocalWalletBadge(t0) {
  const $ = _c(13);
  const {
    wallet
  } = t0;
  let t1;
  if ($[0] !== wallet.image) {
    t1 = wallet.image && getDisplayImageUrl(wallet.image);
    $[0] = wallet.image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const imageUrl = t1;
  let t2;
  if ($[2] !== imageUrl || $[3] !== wallet.bapId || $[4] !== wallet.label) {
    t2 = imageUrl ? <OptimizedImage alt={wallet.label} className="h-9 w-9 rounded-full ring-1 ring-border" height={36} quality={90} src={imageUrl} width={36} /> : <div className="h-9 w-9 overflow-hidden rounded-full bg-muted ring-1 ring-border"><Avatar colors={["var(--chart-1)", "var(--chart-2)", "var(--chart-3)", "var(--chart-4)", "var(--chart-5)"]} name={wallet.bapId} size={36} variant="pixel" /></div>;
    $[2] = imageUrl;
    $[3] = wallet.bapId;
    $[4] = wallet.label;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="text-muted-foreground text-xs">Wallet stored on this device</div>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== wallet.bapId || $[8] !== wallet.label) {
    t4 = <div className="min-w-0">{t3}<div className="truncate font-medium text-sm" title={wallet.bapId}>{wallet.label}</div></div>;
    $[7] = wallet.bapId;
    $[8] = wallet.label;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <div className="flex items-center gap-3 rounded-md border border-border/70 px-3 py-2 text-left" data-testid="local-wallet-identity">{t2}{t4}</div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}